import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

const storage = getStorage();

async function uploadImage(file) {
  if (file !== null) {
    const timestamp = new Date().toISOString(); 
    const formattedTimestamp = timestamp.replace(/[^0-9]/g, ""); 
    const fileName = `file_${formattedTimestamp}`; 

    const imgRef = ref(storage, `files/${fileName}`);
    
    try {
      const snapshot = await uploadBytes(imgRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  }
  return null; 
}
async function uploadPDFFile(pdfFile) {
  if (pdfFile !== null) {
    const timestamp = new Date().toISOString();
    const formattedTimestamp = timestamp.replace(/[^0-9]/g, '');
    const fileName = `file_${formattedTimestamp}.pdf`;

    const pdfRef = ref(storage, `pdfs/${fileName}`);

    try {
      const snapshot = await uploadBytes(pdfRef, pdfFile);
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    } catch (error) {
      console.error('Error uploading PDF file:', error);
      throw error;
    }
  }
  return null;
}

export { uploadImage, uploadPDFFile };